import {ExperimentNames, getInputControlMeta} from '@wix/wix-events-commons-statics'
import {useExperiments} from '@wix/yoshi-flow-editor'
import React, {useEffect} from 'react'
import {Error} from '../../commons/error'
import {Label} from '../../commons/label'
import {Radio as RadioItem} from '../../commons/radio'
import fs from '../../fields.scss'
import {RadioProps} from './interfaces'
import s from './radio.scss'

export const Radio = ({input: {value, onChange}, control, meta: {dirty, touched, error}, t}: RadioProps) => {
  const {experiments} = useExperiments()
  const {label, options, mandatory} = getInputControlMeta(control)

  const persistSingleChoiceMandatoryViewerEnabled = experiments.enabled(
    ExperimentNames.PersistSingleChoiceMandatoryViewer,
  )

  useEffect(() => {
    if (persistSingleChoiceMandatoryViewerEnabled && value) {
      onChange(value)
    } else if (!persistSingleChoiceMandatoryViewerEnabled) {
      onChange(value || options[0])
    }
  }, [])

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    const selectedOptionIndex = options.findIndex(option => option === value) || 0

    switch (event.keyCode) {
      case 37: // arrow left
      case 38: // arrow up
        event.preventDefault()
        if (selectedOptionIndex > 0) {
          onChange(options[selectedOptionIndex - 1])
        } else {
          onChange(options[options.length - 1])
        }
        return

      case 39: // arrow right
      case 40: // arrow down
        event.preventDefault()
        if (selectedOptionIndex < options.length - 1) {
          onChange(options[selectedOptionIndex + 1])
        } else {
          onChange(options[0])
        }
        return

      default:
        return
    }
  }

  const renderOption = (option: string, idx: number) => {
    const {name} = getInputControlMeta(control)

    return (
      <div className={s.option} key={idx}>
        <RadioItem name={name} value={option} checked={value === option} onChange={onChange} />
      </div>
    )
  }

  return (
    <div className={fs.field} tabIndex={0} onKeyDown={handleKeyDown}>
      <Label
        classes={fs.customCaption}
        dataHook="radio-caption"
        required={persistSingleChoiceMandatoryViewerEnabled ? mandatory : false}
        caption={label}
      />
      <div role="radiogroup">{options.map(renderOption)}</div>
      {persistSingleChoiceMandatoryViewerEnabled && <Error error={(dirty || touched) && error && t(error)} />}
    </div>
  )
}
